import apiClient from './apiClient';

const vendorsService = {
  // Get all vendors for current authenticated user
  getMerchantVendors: async () => {
    // Session-based: uses authenticated user from req.user
    const response = await apiClient.get('/vendors');
    return response.data;
  },

  // Get single vendor
  getVendor: async (vendorId) => {
    const response = await apiClient.get(`/vendors/${vendorId}`);
    return response.data;
  },

  // Create vendor
  createVendor: async (data) => {
    const response = await apiClient.post('/vendors', data);
    return response.data;
  },

  // Update vendor
  updateVendor: async (vendorId, data) => {
    const response = await apiClient.put(`/vendors/${vendorId}`, data);
    return response.data;
  },

  // Delete vendor
  deleteVendor: async (vendorId) => {
    const response = await apiClient.delete(`/vendors/${vendorId}`);
    return response.data;
  }
};

export default vendorsService;